export const BUSINESS_FLOW_PANELS = [
  {
    key: 'overview',
    title: '总览',
    notes: [
      '两层单据：业务单（订单/通知/工单）下达或确认后不占库存；出入库类单据审核后才动账。',
      '采购：到货通知审核后办理来料检验（参数 purchase-iqc-required=1 且物料须检时必走），已审检验单再下推采购入库。',
      '销售可下推生产工单；MRP/计划单可转工单或采购。',
      '退货：先退货单审核，再退货出入库审核。'
    ],
    lanes: [
      { key: 'sale', title: '销售出库链', color: '#409EFF', mergeLabel: '减库存', steps: [
        { label: '销售订单', action: '确认', menuUrl: 'sale/salesOrder', perm: 'sale:salesOrder:list' },
        { label: '发货通知', action: '审核', menuUrl: 'sale/salesShippingNotice', perm: 'sale:salesShippingNotice:list' },
        { label: '销售出库', action: '审核减库存', menuUrl: 'sale/salesStockOut', perm: 'sale:salesStockOut:list' }
      ] },
      { key: 'purchase', title: '采购入库链', color: '#E6A23C', mergeLabel: '加库存', steps: [
        { label: '采购请购', action: '审核', menuUrl: 'purchase/purchaseRequisition', perm: 'purchase:purchaseRequisition:list' },
        { label: '采购订单', action: '确认', menuUrl: 'purchase/purchaseOrder', perm: 'purchase:purchaseOrder:list' },
        { label: '到货通知', action: '审核', menuUrl: 'purchase/purchaseArrivalNotice', perm: 'purchase:purchaseArrivalNotice:list' },
        { label: '来料检验', action: '审核（启用IQC时）', menuUrl: 'purchase/purchaseIncomingInspection', perm: 'purchase:purchaseIncomingInspection:list' },
        { label: '采购入库', action: '审核加库存', menuUrl: 'purchase/purchaseStockIn', perm: 'purchase:purchaseStockIn:list' }
      ] },
      { key: 'plm', title: '研发设计链', color: '#9254DE', mergeLabel: '供MRP/生产', steps: [
        { label: '工程文档', action: '检出/发布', menuUrl: 'plm/plmDocument', perm: 'plm:plmDocument:list' },
        { label: 'EBOM', action: '设计维护', menuUrl: 'plm/plmEbom', perm: 'plm:plmEbom:list' },
        { label: '工艺发布', action: '发布', menuUrl: 'plm/plmRoutingRelease', perm: 'plm:plmRoutingRelease:list' },
        { label: '产品发布', action: '量产门禁', menuUrl: 'plm/plmItem', perm: 'plm:plmItem:list' }
      ] },
      { key: 'production', title: '生产制造链', color: '#67C23A', mergeLabel: '领退料/入库', steps: [
        { label: '生产工单', action: '下达', menuUrl: 'production/productionOrder', perm: 'production:productionOrder:list' },
        { label: '生产领料', action: '审核减库存', menuUrl: 'production/productionIssue', perm: 'production:productionIssue:list' },
        { label: '工序报工', action: '审核', menuUrl: 'production/productionReport', perm: 'production:productionReport:list' },
        { label: '完工入库', action: '审核加库存', menuUrl: 'production/productionReceipt', perm: 'production:productionReceipt:list' }
      ] },
      { key: 'inventory', title: '库存中心', color: '#1aa5b7', hub: true, steps: [
        { label: '现存量台账', action: '查询', menuUrl: 'inventory/quantitySearch', perm: 'quantity:search:list' },
        { label: '其他入出库', action: '审核入账', menuUrl: 'inventory/otherIn', perm: 'inventory:otherIn:list' },
        { label: '调拨/盘点', action: '审核', menuUrl: 'inventory/transfer', perm: 'inventory:transfer:list' }
      ] },
      { key: 'finance', title: '财务闭环', color: '#909399', steps: [
        { label: '应收/应付', action: '来自已审出入库', menuUrl: 'finance/receivable', perm: 'finance:receivable:list' },
        { label: '发票/收付款', action: '审核核销', menuUrl: 'finance/invoiceSales', perm: 'finance:invoiceSales:list' },
        { label: '记账凭证', action: '审核记账', menuUrl: 'finance/voucher', perm: 'finance:voucher:list' },
        { label: '会计期间', action: '结账', menuUrl: 'finance/period', perm: 'finance:period:list' }
      ] }
    ]
  },
  {
    key: 'sale', title: '销售', lanes: [
      { title: '正向销售', color: '#409EFF', steps: [
        { label: '销售订单', action: '开立 → 确认', menuUrl: 'sale/salesOrder', perm: 'sale:salesOrder:list' },
        { label: '发货通知', action: '审核（可分批）', menuUrl: 'sale/salesShippingNotice', perm: 'sale:salesShippingNotice:list' },
        { label: '销售出库', action: '审核减库存', menuUrl: 'sale/salesStockOut', perm: 'sale:salesStockOut:list' },
        { label: '应收单', action: '挂账', menuUrl: 'finance/receivable', perm: 'finance:receivable:list' },
        { label: '销售发票', action: '审核', menuUrl: 'finance/invoiceSales', perm: 'finance:invoiceSales:list' },
        { label: '收款单', action: '审核核销', menuUrl: 'finance/receipt', perm: 'finance:receipt:list' }
      ] },
      { title: '销售退货', color: '#F56C6C', steps: [
        { label: '销售退货单', action: '审核（不占库存）', menuUrl: 'sale/salesReturn', perm: 'sale:salesReturn:list' },
        { label: '退货入库', action: '审核加库存', menuUrl: 'sale/salesStockReturn', perm: 'sale:salesStockReturn:list' },
        { label: '退货结算', action: '审核冲减', menuUrl: 'finance/salesReturnSettle', perm: 'finance:salesReturnSettle:list' }
      ] },
      { title: '联动生产', color: '#67C23A', steps: [
        { label: '销售订单', action: '已确认行', menuUrl: 'sale/salesOrder', perm: 'sale:salesOrder:list' },
        { label: '下推工单', action: '单行/合并', menuUrl: 'production/productionOrder', perm: 'production:productionOrder:fromSales' },
        { label: '生产执行', action: '领料→入库', menuUrl: 'production/productionIssue', perm: 'production:productionIssue:list' }
      ] }
    ]
  },
  {
    key: 'purchase', title: '采购', lanes: [
      { title: '请购转采购', color: '#E6A23C', steps: [
        { label: '采购请购', action: '审核', menuUrl: 'purchase/purchaseRequisition', perm: 'purchase:purchaseRequisition:list' },
        { label: '转采购订单', action: '开立 PO', menuUrl: 'purchase/purchaseOrder', perm: 'purchase:purchaseOrder:save' },
        { label: '采购订单', action: '确认', menuUrl: 'purchase/purchaseOrder', perm: 'purchase:purchaseOrder:list' }
      ] },
      { title: '询价采购', color: '#E6A23C', steps: [
        { label: '采购询价', action: '审核', menuUrl: 'purchase/purchaseInquiry', perm: 'purchase:purchaseInquiry:list' },
        { label: '选标转 PO', action: '按供应商', menuUrl: 'purchase/purchaseOrder', perm: 'purchase:purchaseOrder:save' }
      ] },
      { title: '到货入库', color: '#409EFF', steps: [
        { label: '到货通知', action: '审核', menuUrl: 'purchase/purchaseArrivalNotice', perm: 'purchase:purchaseArrivalNotice:list' },
        { label: '来料检验', action: '审核（启用IQC时）', menuUrl: 'purchase/purchaseIncomingInspection', perm: 'purchase:purchaseIncomingInspection:list' },
        { label: '采购入库', action: '审核加库存', menuUrl: 'purchase/purchaseStockIn', perm: 'purchase:purchaseStockIn:list' },
        { label: '应付单', action: '挂账', menuUrl: 'finance/payable', perm: 'finance:payable:list' },
        { label: '采购发票', action: '审核', menuUrl: 'finance/invoicePurchase', perm: 'finance:invoicePurchase:list' },
        { label: '付款单', action: '审核核销', menuUrl: 'finance/payment', perm: 'finance:payment:list' }
      ] },
      { title: '采购退货', color: '#F56C6C', steps: [
        { label: '采购退货单', action: '审核', menuUrl: 'purchase/purchaseReturn', perm: 'purchase:purchaseReturn:list' },
        { label: '退货出库', action: '审核减库存', menuUrl: 'purchase/purchaseStockReturn', perm: 'purchase:purchaseStockReturn:list' }
      ] }
    ]
  },
  {
    key: 'production', title: '生产', lanes: [
      { title: '工单执行', color: '#67C23A', steps: [
        { label: '生产工单', action: '下达', menuUrl: 'production/productionOrder', perm: 'production:productionOrder:list' },
        { label: '生产领料', action: '审核减库存', menuUrl: 'production/productionIssue', perm: 'production:productionIssue:list' },
        { label: '生产退料', action: '审核加库存', menuUrl: 'production/productionReturn', perm: 'production:productionReturn:list' },
        { label: '完工入库', action: '审核加库存', menuUrl: 'production/productionReceipt', perm: 'production:productionReceipt:list' },
        { label: '工单关闭', action: '可先结算', menuUrl: 'production/productionSettle', perm: 'production:productionSettle:list' }
      ] },
      { title: '计划与排产', color: '#1aa5b7', steps: [
        { label: '需求汇总', action: 'MTO/MTS', menuUrl: 'production/productionDemand', perm: 'production:productionDemand:list' },
        { label: 'MRP 运算', action: '生成建议', menuUrl: 'production/mrpRun', perm: 'production:mrpRun:list' },
        { label: '计划订单', action: '转工单/采购', menuUrl: 'production/plannedOrder', perm: 'production:plannedOrder:list' },
        { label: '生产排产', action: '甘特/机台', menuUrl: 'production/productionSchedule', perm: 'production:productionSchedule:list' }
      ] }
    ]
  },
  {
    key: 'finance', title: '财务', lanes: [
      { title: '往来与结算', color: '#909399', steps: [
        { label: '销售出库', action: '已审', menuUrl: 'sale/salesStockOut', perm: 'sale:salesStockOut:list' },
        { label: '应收单', action: '挂账', menuUrl: 'finance/receivable', perm: 'finance:receivable:list' },
        { label: '收款/发票', action: '核销', menuUrl: 'finance/receipt', perm: 'finance:receipt:list' },
        { label: '采购入库', action: '已审', menuUrl: 'purchase/purchaseStockIn', perm: 'purchase:purchaseStockIn:list' },
        { label: '应付单', action: '挂账', menuUrl: 'finance/payable', perm: 'finance:payable:list' },
        { label: '付款/发票', action: '核销', menuUrl: 'finance/payment', perm: 'finance:payment:list' }
      ] },
      { title: '总账与成本', color: '#1aa5b7', steps: [
        { label: '记账凭证', action: '审核=记账', menuUrl: 'finance/voucher', perm: 'finance:voucher:list' },
        { label: '科目余额', action: '查询', menuUrl: 'finance/subjectBalance', perm: 'finance:subjectBalance:list' },
        { label: '期间结账', action: '月结', menuUrl: 'finance/period', perm: 'finance:period:list' },
        { label: '损益结转', action: '结转本期损益', menuUrl: 'finance/profitClosing', perm: 'finance:profitClosing:list' }
      ] }
    ]
  }
]
